import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height pa-0 mt-2",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [!_vm.$vuetify.breakpoint.smAndDown ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item-three-line"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": _vm.$vuetify.breakpoint.smAndDown ? 7 : 12,
      "md": _vm.$vuetify.breakpoint.smAndDown ? 12 : 4,
      "align": _vm.$vuetify.breakpoint.smAndDown ? undefined : 'right'
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item-three-line"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "5"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "image, image"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "image, image"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item, image"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };